module.exports = __webpack_public_path__ + "media/images/checkout/challenger/unit_10x50-0d6f8be986323e35433b3897ff813616.png";